// extracted by mini-css-extract-plugin
export default {"wrapper":"Ury0V","slide":"kD4Cp","grid":"M5DVW"};